module.exports = __webpack_public_path__ + "static/img/5308_phase_function_Paper_PointsHejduk_Prediction.9501a0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5308_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 52gV
// module chunks = 0